<main class="container mt-5">
  <div class="row justify-content-lg-center">
    <div class="col-lg-8">
      <div class="card rounded holder">
        <div class="card-body">
          <h4 class="text-dark mb-3">Reset your password</h4>
          <ng-container *ngIf="!submitted">
            <alert type="info">
              <p>Your new password need to satisfy the following password policies:</p>
              <ul>
                <li>12 characters minimum</li>
                <li>At least 1 number</li>
                <li>At least 1 uppercase letter</li>
                <li>At least 1 lowercase letter</li>
                <li>At least 1 special character</li>
              </ul>
            </alert>
            <form [formGroup]="resetForm" (ngSubmit)="onSubmitNewPasswordForm()">
              <div class="form-group mb-3">
                <input class="form-control"
                       type="{{showPasswords ? 'text' : 'password'}}"
                       formControlName="password"
                       #password
                       [ngClass]="{'is-invalid': resetForm.get('password').touched && !resetForm.get('password').valid}"
                       placeholder="New password" aria-label="" autofocus/>
                <!-- TODO: replace password meter -->
                <!-- <password-strength-meter [password]="resetForm.controls.password.value"></password-strength-meter>-->
                <div class="my-2">
                  <mat-password-strength #passwordComponent [password]="resetForm.controls.password.value" [min]="12" class="green" />
                </div>
                <div class="invalid-feedback"
                     *ngIf="resetForm.get('password').touched && resetForm.get('password').hasError('pattern')">
                  Your password doesn't satisfy the password policies.
                </div>
                <div class="invalid-feedback"
                     *ngIf="resetForm.get('password').touched && resetForm.get('password').hasError('required')">
                  This field is required.
                </div>
              </div>
              <div class="form-group mb-3">
                <input class="form-control"
                       type="{{showPasswords ? 'text' : 'password'}}"
                       formControlName="passwordConfirm"
                       [ngClass]="{'is-invalid': resetForm.get('passwordConfirm').touched && (!resetForm.valid || !resetForm.get('passwordConfirm').valid)}"
                       placeholder="Confirm new password" aria-label="" autofocus/>
                <div class="invalid-feedback" *ngIf="resetForm.hasError('notSamePassword')">
                  Password confirmation doesn't match new password
                </div>
                <div class="invalid-feedback" *ngIf="resetForm.get('passwordConfirm').hasError('required')">
                  This field is required
                </div>
              </div>
              <div class="show-password form-check col-sm-12 col-md-6 mb-3">
                <input type="checkbox" class="form-check-input" id="showPassword" [checked]="showPasswords"
                       (change)="showPasswords = !showPasswords">
                <label class="form-check-label" for="showPassword"><small>Show password</small></label>
              </div>
              <button type="submit" class="btn btn-primary float-end d-inline-block">Save password</button>
              <button type="button" class="btn btn-secondary float-end d-inline-block me-2" [routerLink]="['/']">
                Cancel
              </button>
            </form>
          </ng-container>
          <ng-container *ngIf="submitted && !error">
            <alert type="success" class="mt-3">
              Your password has been changed. You can now login using your new password.
            </alert>
            <button type="button" class="btn btn-secondary float-end d-inline-block" [routerLink]="['/']">Back to
              login
            </button>
          </ng-container>
          <ng-container *ngIf="submitted && error">
            <alert type="danger" class="mt-3">
              {{error}}
            </alert>
            <button type="button" class="btn btn-secondary float-end d-inline-block" [routerLink]="['/']">Back to
              login
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</main>

